<template>
  <div class="mfa-step">
    <div class="mfa-step_header">
      <div>
        <img :src="googleAuth" width="64" alt="Google Auth" />
      </div>
      <h2>Autenticación en 2 pasos con Google Authenticator</h2>
      <p>
        Primero, descarga la aplicación Google Authenticator desde la tienda <br/>
        oficial de tu dispositivo móvil. Te mostramos los enlaces de ayuda:
      </p>
    </div>
    <div class="mfa-stores">
      <a :href="linkAppStore" target="_blank">
        <img :src="appStore" alt="App Store" />
      </a>
      <a :href="linkGooglePlay" target="_blank">
        <img :src="playStore" alt="Google Play" />
      </a>
    </div>
    <div class="mfa-step_footer">
      <p>Una vez instalada, sigue los pasos del aplicativo y continúa al siguiente paso:</p>
      <a-button type="primary" @click="$emit('next')">Continuar</a-button>
    </div>
    <div class="mfa-help">
      Para mayor información:
      <a-typography-link :href="urlGoogleAuth" target="_blank">
        Leer más sobre Google Authenticator
        <ImportOutlined />
      </a-typography-link>
    </div>
  </div>
</template>

<script setup lang="ts">
import googleAuth from "@/app/auth/assets/google_auth.png?url";
import appStore from "@/app/auth/assets/appstore.png?url";
import playStore from "@/app/auth/assets/playstore.png?url";
import { ImportOutlined } from "@ant-design/icons-vue";

const urlGoogleAuth = import.meta.env.VITE_GOOGLE_AUTH_TUTORIAL;
const linkAppStore = "https://apps.apple.com/es/app/google-authenticator/id388497605";
const linkGooglePlay = "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2" 
</script>

<style scoped lang="sass">
.mfa-step
  text-align: center
  flex-direction: column
  display: flex
  gap: 24px
  justify-content: center
  justify-items: center
  align-items: center
  &_header
    display: flex
    flex-direction: column
    gap: 16px
    text-align: center
  h2
    font-weight: 600
    margin-bottom: 0
    font-size: 24px
    line-height: 32px
  p
    margin: 0
    color: #000000A6
    font-size: 14px
  &_footer
    max-width: 420px
    display: flex
    flex-direction: column
    gap: 16px
    text-align: center

  .mfa-stores
    display: flex
    justify-content: center
    gap: 1rem

    img
      height: 40px

  .mfa-help
    margin-top: 8px
    font-size: 14px
    color: #000000A6
    display: flex
    gap: 8px
    align-items: center
    a
      display: flex
      gap: 6px
      align-items: center
</style>
